import axios from 'axios';

type NextConflictField = {
  field: string,
  accValue: string | number | null,
  nextValue: string | number | null,
};

export type NextPurchaseConflict = {
  nextPurchaseId: number,
  areaId: string,
  name: string,
  accountNumber?: string,
  fields: NextConflictField[],
};

export type NextExportPreview = {
  purchasesTotal: number,
  newPurchases: number,
  willBeRecreated: string[],
  // Linked purchases deleted in Next that can NOT be recreated (account gone).
  missingAccounts: string[],
  conflicts: NextPurchaseConflict[],
  totalConflictFields: number,
};

export type NextPurchaseUpdate = {
  nextPurchaseId: number,
  fields: string[],
};

class ServiceNextProjectController {
  async listProjects() {
    const response = await axios.get('/api/next-project/projects');
    return response.data;
  }

  async importProjects(ids: number[], updates?: NextPurchaseUpdate[]) {
    const response = await axios.post('/api/next-project/import', { ids, updates });
    return response.data;
  }

  async previewImport(nextProjectId: number): Promise<NextExportPreview> {
    const response = await axios.post('/api/next-project/import/preview', { nextProjectId });
    return response.data;
  }

  async previewExport(projectId: string): Promise<NextExportPreview> {
    const response = await axios.post('/api/next-project/export/preview', { projectId });
    return response.data;
  }

  async exportProject(projectId: string, parentProjectId?: number, parentCustomerId?: number, updates?: NextPurchaseUpdate[]) {
    const response = await axios.post('/api/next-project/export', { projectId, parentProjectId, parentCustomerId, updates });
    return response.data;
  }

  async listCustomers() {
    const response = await axios.get('/api/next-project/customers');
    return response.data;
  }

  async checkCustomerExists(customerId: number) {
    const response = await axios.get(`/api/next-project/customers/${customerId}`);
    return response.data;
  }
}

export const ServiceNextProject = new ServiceNextProjectController();
